export default __webpack_public_path__ + "static/media/1-oz-generic-gold-bar-999-9999-fine-ira-approved-secondary-market--132084748029371735.56e9414f.jpg";